module.exports = __webpack_public_path__ + "static/media/troubleshootLens.1bde7ec9.png";